import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'kt-pv1-more-details-dialog',
  templateUrl: './pv1-more-details-dialog.component.html',
  styleUrls: ['./pv1-more-details-dialog.component.scss'],
})
export class Pv1MoreDetailsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<Pv1MoreDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}
}
